import React, { useState } from "react";
import { Container, Row, Col, Button, Form, Alert } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaEnvelope, FaPhoneAlt, FaUser } from "react-icons/fa";
import emailjs from "emailjs-com";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_n0bvg4s", // ✅ Your EmailJS service ID
        "template_3wiqmwj", // ✅ Your EmailJS template ID
        formData,
        "your_user_id" // ✅ Your public key from EmailJS
      )
      .then(
        () => {
          setSuccess(true);
          setError(false);
          setFormData({ name: "", email: "", message: "" });
          setTimeout(() => setSuccess(false), 5000);
        },
        () => {
          setError(true);
          setSuccess(false);
          setTimeout(() => setError(false), 5000);
        }
      );
  };

  return (
    <motion.section
      id="contact"
      className="contact-section bg-white py-5"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <Container>
        <h2 className="text-center fw-bold mb-4 display-5 text-dark">
          Get in Touch
        </h2>
        <p className="text-center text-muted mb-5">
          Let’s build something amazing together. I’m open for freelance work and collaborations.
        </p>

        {/* 📞 External Contact Info */}
        <Row className="justify-content-center mb-4">
          <Col md={6} className="text-center">
            <div className="external-contact-info bg-light p-4 rounded shadow-sm">
              <p className="mb-2"><FaUser className="me-2 text-primary" /> <strong>Pratik Satalkar</strong></p>
              <p className="mb-2"><FaEnvelope className="me-2 text-primary" /> satalkarpratik0@gmail.com</p>
              <p><FaPhoneAlt className="me-2 text-primary" /> +91 93071 32146</p>
            </div>
          </Col>
        </Row>

        {/* 📝 Contact Form */}
        <Row className="justify-content-center">
          <Col md={8}>
            <div className="contact-form-wrapper p-4 shadow-lg rounded bg-light">
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formName">
                  <Form.Label>Your Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label>Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Form.Group className="mb-4" controlId="formMessage">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="message"
                    rows={5}
                    placeholder="Describe your project or say hello..."
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
                <Button variant="primary" type="submit" className="w-100">
                  Send Message 🚀
                </Button>

                {success && (
                  <Alert variant="success" className="mt-3">
                    ✅ Message sent! I'll reply shortly.
                  </Alert>
                )}
                {error && (
                  <Alert variant="danger" className="mt-3">
                    ❌ Something went wrong. Please try again later.
                  </Alert>
                )}
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </motion.section>
  );
};

export default Contact;
